import { memo } from 'react';

function CloseRed(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
			{...props}
		>
			<path stroke="red" strokeWidth="1.5" d="M16 4L4 16M4 4l12 12"></path>
		</svg>
	);
}

export default memo(CloseRed);
